import { styled, Text as TamaguiText } from "@tamagui/core";
import { createContext, useContext } from "react";
import { jsx } from "react/jsx-runtime";
const DEFAULT_BOLD = !1,
  DEFAULT_SIZE = "regular",
  DEFAULT_VARIANT = "primary",
  InternalText = styled(TamaguiText, {
    accessibilityRole: "text",
    color: "$text-primary",
    defaultVariants: {
      bold: DEFAULT_BOLD,
      size: DEFAULT_SIZE,
      variant: DEFAULT_VARIANT
    },
    fontFamily: "$body",
    fontSize: "$regular",
    fontWeight: "400",
    lineHeight: "$regular",
    name: "TypographyText",
    variants: {
      bold: {
        false: {
          fontWeight: "400"
        },
        true: {
          fontWeight: "500"
        }
      },
      size: {
        large: {
          fontSize: "$large",
          lineHeight: "$large"
        },
        regular: {
          fontSize: "$regular",
          lineHeight: "$regular"
        },
        small: {
          fontSize: "$small",
          lineHeight: "$small"
        },
        tiny: {
          fontSize: "$tiny",
          lineHeight: "$tiny"
        }
      },
      variant: {
        disabled: {
          color: "$text-disabled"
        },
        discreet: {
          color: "$text-discreet"
        },
        error: {
          color: "$text-error"
        },
        primary: {
          color: "$text-primary"
        },
        secondary: {
          color: "$text-secondary"
        },
        success: {
          color: "$text-success"
        },
        white: {
          color: "$text-white"
        }
      }
    }
  }),
  StyleableInternalText = InternalText.styleable((props, ref) => /* @__PURE__ */jsx(InternalText, {
    ...props,
    ref
  })),
  TypographyContext = createContext(void 0);
function Text(props) {
  const parentVariantsContext = useContext(TypographyContext);
  if (parentVariantsContext !== void 0) {
    const {
        bold,
        size,
        variant,
        ...restWithoutSizeAndVariant
      } = props,
      appliedSize = size || parentVariantsContext.size,
      appliedVariant = variant || parentVariantsContext.variant,
      appliedBold = bold || parentVariantsContext.bold;
    return /* @__PURE__ */jsx(InternalText, {
      bold: appliedBold,
      size: appliedSize,
      tag: "span",
      variant: appliedVariant,
      ...restWithoutSizeAndVariant
    });
  } else return /* @__PURE__ */jsx(TypographyContext.Provider, {
    value: {
      bold: props.bold || DEFAULT_BOLD,
      size: props.size || DEFAULT_SIZE,
      variant: props.variant || DEFAULT_VARIANT
    },
    children: /* @__PURE__ */jsx(InternalText, {
      tag: "p",
      ...props
    })
  });
}
Text.displayName = "Typography.Text";
export { DEFAULT_BOLD, DEFAULT_SIZE, DEFAULT_VARIANT, InternalText, StyleableInternalText, Text, TypographyContext };
//# sourceMappingURL=Typography.Text.mjs.map
